import React, { useState, forwardRef } from 'react';
import './button_style.css'


const CustomButton = forwardRef(({ onClick, children, ...props }, ref) => {
  const [isActive, setIsActive] = useState(false);

  const handleTouchStart = () => {
    setIsActive(true);
  };

  const handleTouchEnd = () => {
    setIsActive(false);
  };

  return (
    <button
      type="button"
      onClick={onClick}
      className={`custom-button ${isActive ? 'active' : ''}`}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      onMouseDown={handleTouchStart} // Для поддержки ПК
      onMouseUp={handleTouchEnd} // Для поддержки ПК
      {...props}
    >
      {children}
    </button>
  );
});

export default CustomButton;